export default {
  super_admin: "Super Admin",
  account_owner: "Account Owner",
  account_admin: "Account Admin",
  account_viewer: "Account Viewer",
  site_admin: "Worksite Admin",
  operator: "Operator",
};
